module.exports = __webpack_public_path__ + "/images/assets/DSJSR_header.da12f469.jpg";